module.exports = __webpack_public_path__ + "static/img/logo-itau.29f53df3.png";